import type { RegularFilterConfig } from '../models'

import { until } from '@vueuse/core'
import { useEndpoints } from '../composables/use-endpoints'
import {
  ActiveFilterEnum,
  CompareFilterEnum,
  EnabledFilterEnum,
  FilterIdEnum,
  FilterTypeEnum,
} from '../enums'

export const COMPARE_FILTER_CONFIG: RegularFilterConfig = {
  id: FilterIdEnum.COMPARE,
  type: FilterTypeEnum.REGULAR,
  multiselectDisabled: true,
  sortValuesDisabled: true,
  emptyMeansNone: true,
  values: [
    {
      id: CompareFilterEnum.PREVIOUS_PERIOD,
    },
    {
      id: CompareFilterEnum.YEAR_OVER_YEAR,
    },
  ],
}

export const ENABLED_FILTER_CONFIG: RegularFilterConfig = {
  id: FilterIdEnum.ENABLED,
  type: FilterTypeEnum.REGULAR,
  multiselectDisabled: true,
  sortValuesDisabled: true,
  values: [
    {
      id: EnabledFilterEnum.ENABLED,
    },
    {
      id: EnabledFilterEnum.DISABLED,
    },
  ],
}

export const ACTIVE_FILTER_CONFIG: RegularFilterConfig = {
  id: FilterIdEnum.ACTIVE,
  type: FilterTypeEnum.REGULAR,
  multiselectDisabled: true,
  sortValuesDisabled: true,
  values: [
    {
      id: ActiveFilterEnum.ACTIVE,
    },
    {
      id: ActiveFilterEnum.INACTIVE,
    },
  ],
}

export const ENDPOINT_FILTER_CONFIG: RegularFilterConfig = {
  id: FilterIdEnum.ENDPOINT,
  type: FilterTypeEnum.REGULAR,
  sortValuesDisabled: true,
  values: [],
  getAsyncValues: async () => {
    const { endpoints } = useEndpoints()

    await until(endpoints).toMatch(resultEndpoints => !!resultEndpoints.length)

    return endpoints.value.map(endpoint => ({
      id: endpoint.value,
    }))
  },
}
